import { render, staticRenderFns } from "./SoftwareList.vue?vue&type=template&id=1b61f492&scoped=true&"
import script from "./SoftwareList.vue?vue&type=script&lang=ts&"
export * from "./SoftwareList.vue?vue&type=script&lang=ts&"
import style0 from "./SoftwareList.vue?vue&type=style&index=0&id=1b61f492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b61f492",
  null
  
)

export default component.exports